<link href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css" rel="stylesheet"
    integrity="sha384-1BmE4kWBq78iYhFldvKuhfTAU6auU8tT94WrHftjDbrCEXSU1oBoqyl2QvZ6jIW3" crossorigin="anonymous">

<script src="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/js/bootstrap.bundle.min.js"
    integrity="sha384-ka7Sk0Gln4gmtz2MlQnikT1wXgYsOg+OMhuP+IlRH9sENBO0LRn5q+8nbTov4+1p"
    crossorigin="anonymous"></script>

<div class="w-100 card mt-3 bg-light" [ngClass]="{'border-danger': component.title ==''}" cdkDrag [cdkDragDisabled]="inputFocus">
    <div class="card-header d-flex" (click)="toggleView($event.target.parentElement.parentElement)" >
        <h2 class="m-0 w-100" *ngIf="component.title != ''">{{component.title}}</h2>
        <h2 class="m-0 w-100 error-label" *ngIf="component.title == ''">Digite a pergunta</h2>
        <h2 class="w-100 m-0" style="text-align: end;user-select: none;">#{{component.component_id}}</h2>
    </div>
    <div class="card-body">

        <h5 class="card-title">Pergunta de Imagens</h5>
        <label for="basic-url" class="form-label">Pergunta</label>
        <div class="input-group mb-3">
            <span class="input-group-text" id="input_{{position}}_span">?</span>
            <input (mousedown)="$event.stopPropagation()"  id="input_title_{{position}}" type="text" class="form-control"aria-describedby="input_1_span" value="{{component.title}}" (change)="component.title = $event.target.value">
        </div>

        <h5 class="card-title">Coleta de imagens</h5>
        <h6 class="card-subtitle mb-2 text-muted">Preencha as informações da coleta de imagens</h6>

    
        <div class="row">
            <div class="col-auto">
                <label for="basic-url" class="form-label">Quantidade total de imagens</label>
                <div class="input-group mb-3">
                    <input (mousedown)="$event.stopPropagation()"  type="number" class="form-control" id="input_1" aria-describedby="input_1_span" value="{{component.size ? component.size : 0}}" (change)="component.size = number($event.target.value)">
                </div>

            </div>

            <div class="col-auto">
                <label for="basic-url" class="form-label">Coletar ao menos</label>
                <div class="input-group mb-3">
                    <input (mousedown)="$event.stopPropagation()"  type="number" class="form-control" id="input_1" aria-describedby="input_1_span" max="{{component.size}}" value="{{component.min_required ? component.min_required : 0}}" (change)="setMinRequired($event.target.value)">
                </div>

            </div>

            <div class="col-auto">
                <label for="basic-url" class="form-label">Pontos por imagem</label>
                <div class="input-group mb-3">
                    <input (mousedown)="$event.stopPropagation()"  type="number" class="form-control" id="input_1" aria-describedby="input_1_span" value="{{component.image_points ? component.image_points : 0}}" (change)="component.image_points = number($event.target.value)">
                </div>

            </div>
        </div>

    </div>
    <div class="card-footer">
        <div class="d-flex">
            <div class="ml-auto">
                <button class="btn btn-danger" (click)="deleteCurrentComponent()">Remover</button>
            </div>
        </div>
    </div>
</div>
